import { BaseComponent } from 'src/app/_core/tools/base.component';
import { KalPaginatorComponent } from 'src/app/_shared/modules/kal-table/kal-paginator/kal-paginator.component';
import { UserUpdateApplicationParametersAction } from 'src/app/_user/store/user/user.action';
import { UserState } from 'src/app/_user/store/user/user.state';

export abstract class BaseListComponent extends BaseComponent {

    protected abstract readonly defaultPageSizeCode: string;

    get paginationSize(): number {
        return +this.snapshot(UserState.applicationParameters).find(({CodeChamp}) => CodeChamp === this.defaultPageSizeCode).CodeValeur
            || KalPaginatorComponent.defaultPageSize;
    }

    set paginationSize(pageSize: number) {
        this.dispatch$(new UserUpdateApplicationParametersAction([{CodeChamp: this.defaultPageSizeCode, CodeValeur: '' + pageSize}]));
    }

    get paginationRowsByPageList(): number[] {
        const parameterSize = this.paginationSize;
        const rowsSize = [...KalPaginatorComponent.defaultRowsByPageList];

        if (parameterSize && rowsSize.every(rowSize => rowSize !== parameterSize)) {
            rowsSize.push(parameterSize);
            rowsSize.sort((a, b) => a - b);
        }
        return rowsSize;
    }
}
